/* eslint camelcase: 0 */

import { Topic as Data } from '@/typings/api/Topic'
import { Model, createMessages } from '@/helpers/Model'


export class TopicModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить раздел',
    edit: 'Редактировать раздел',
    view: (data: TopicModel) => 'Раздел «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Разделы',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: TopicModel) => 'Удаление раздела «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных разделов',
    delete_all_partly: 'Удаление части выбранных разделов',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
    delete_all_deny: 'Выбранные разделы нельзя удалить',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
